var map = {
	"./1.png": "7a87",
	"./10.png": "c72e",
	"./2.png": "1421",
	"./3.png": "1307",
	"./4.png": "e1ca",
	"./5.png": "7a9a",
	"./6.png": "c1cf",
	"./7.png": "cfcf",
	"./8.png": "21c8",
	"./9.png": "0969"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "83ea";